import { OrderItemResponse } from "@/types/order-type";
import { Package } from "lucide-react";


export function ProductDetailImag({ item }: { item: OrderItemResponse }) {
    return (
        <div className="relative w-12 h-12 flex-shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-slate-50 shadow-sm">
            {item.imageUrl ? (
                <img
                    src={item.imageUrl}
                    alt={item.productName || ""}
                    className="h-full w-full object-cover transition-transform duration-300 hover:scale-110"
                    onError={(e) => {
                        // Fallback if image fails to load
                        (e.target as HTMLImageElement).src = "/placeholder-product.png";
                    }}
                />
            ) : (
                <div className="flex h-full w-full items-center justify-center bg-slate-100">
                    <Package className="h-4 w-4 text-slate-400" />
                </div>
            )}
        </div>
    );
}